import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';
import DatePickerPopover, {
  Props as DatePickerPopoverProps,
} from '../DatePicker/DatePickerPopover';
import { InputIcon } from '../Input/Input';
import {
  default as RawInput,
  type RawInputProps as InputProps,
} from '../Input/RawInput';

const defaultValueFormatter = (
  value: Date,
  showDateSelect?: boolean,
  showTimeSelect?: boolean
) => {
  return `${showDateSelect ? `${value?.toLocaleDateString()} ` : ''}${
    showTimeSelect
      ? value?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      : ''
  }`;
};

export type DateInputProps = Omit<InputProps, 'onChange' | 'value' | 'type'> &
  Pick<
    DatePickerPopoverProps,
    'config' | 'onChange' | 'showTimeSelect' | 'showDateSelect' | 'timeSettings'
  > & {
    value?: Date | null;
    valueFormatter?: (value: Date, showTimeSelect?: boolean) => string;
    businessHours?: Nullish<(string | null)[][]>;
  };

export const DateInput: FC<DateInputProps> = ({
  onChange,
  value,
  showTimeSelect = false,
  showDateSelect = true,
  valueFormatter = defaultValueFormatter,
  businessHours,
  config,
  timeSettings,
  ...rest
}) => {
  const fallbackOnChange = () => null;

  return (
    <div>
      <DatePickerPopover
        onChange={onChange || fallbackOnChange}
        defaultDate={value || config?.dates?.minDate || new Date()}
        showTimeSelect={showTimeSelect}
        showDateSelect={showDateSelect}
        timeSettings={timeSettings}
        businessHours={businessHours}
        config={config}
      >
        {({ setIsOpen }) => (
          <RawInput
            leadingElement={CalendarIcon}
            {...rest}
            value={
              value
                ? valueFormatter(value, showDateSelect, showTimeSelect)
                : undefined
            }
            onFocus={(e) => {
              setIsOpen(true);
              e.target.blur();
            }}
            readOnly
          />
        )}
      </DatePickerPopover>
    </div>
  );
};

const CalendarIcon = <InputIcon name="calendar" />;
